module.exports = __webpack_public_path__ + "static/media/ico-search.af15a240.svg";